import deviceConnectionStatusTypes from '../../../consts/device/deviceConnectionStatusTypes';
import firmwareStatusTypes from '../../../consts/device/firmwareStatusTypes';
import {selectIsDeviceDisconnected} from '../../selectors/iotDevice';
import {selectMwDeviceIsDisconnectedWithNoReconnect} from '../../selectors/mwDevice';
import {setMwDeviceIsDisconnectedWithNoReconnect} from '../mwDevice';
import * as types from './actionTypes';

export const clearIotDevice = () => ({type: types.IOT_DEVICE_CLEAR});

export const setIsDisconnected = () => {
    return (dispatch, getState) => {
        const state = getState();
        const isDeviceDisconnected = selectIsDeviceDisconnected(state);
        const isDisconnectedWithNoReconnect = selectMwDeviceIsDisconnectedWithNoReconnect(state);
        const statusToChange =
            isDisconnectedWithNoReconnect || isDeviceDisconnected
                ? deviceConnectionStatusTypes.DISCONNECTED
                : deviceConnectionStatusTypes.PAIRED;

        dispatch(setConnectedStatus(statusToChange));
    };
};

export const setIsPaired = () => setDeviceConnectionStatus(deviceConnectionStatusTypes.PAIRED);

const setConnectedStatus = (connectionStatus) => {
    return (dispatch, getState) => {
        const state = getState();
        const isDisconnectedWithNoReconnect = selectMwDeviceIsDisconnectedWithNoReconnect(state);

        dispatch(setDeviceConnectionStatus(connectionStatus));

        if (isDisconnectedWithNoReconnect) {
            dispatch(setMwDeviceIsDisconnectedWithNoReconnect(false));
        }
    };
};

export const setIsConnected = () => setConnectedStatus(deviceConnectionStatusTypes.CONNECTED);
export const setIsDeviceReady = () => setConnectedStatus(deviceConnectionStatusTypes.READY);
export const setIsWrongDevice = () => setDeviceConnectionStatus(deviceConnectionStatusTypes.WRONG_DEVICE);
export const setIsDeviceNotSupported = () => setDeviceConnectionStatus(deviceConnectionStatusTypes.NOT_SUPPORTED);

export const setDeviceConnectionStatus = (status) => ({
    type: types.IOT_DEVICE_SET_DEVICE_CONNECTION_STATUS,
    payload: {status},
});

export const clearIotDeviceData = () => ({type: types.IOT_DEVICE_CLEAR_DATA});

export const clearIotDeviceHolderData = () => ({type: types.IOT_DEVICE_CLEAR_HOLDER_DATA});

export const setIsPairingInProgress = (isPairingInProgress) => ({
    type: types.IOT_DEVICE_SET_IS_PAIRING_IN_PROGRESS,
    payload: {isPairingInProgress},
});

export const updateIotDeviceData = (data) => ({
    type: types.IOT_DEVICE_UPDATE_DATA,
    payload: {data},
});

export const setFWUProgress = (progress) => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {progress}},
});

export const setFWUStarted = (fwuTarget) => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {firmwareStatus: firmwareStatusTypes.STARTED, fwuTarget}},
});

export const setFWUFinished = () => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {firmwareStatus: firmwareStatusTypes.FINISHED}},
});

export const setFWUSuccess = () => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {firmwareStatus: firmwareStatusTypes.SUCCESS}},
});

export const setFWUError = (error) => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {firmwareStatus: firmwareStatusTypes.ERROR, error}},
});

export const setFWUCheking = () => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {data: {firmwareStatus: firmwareStatusTypes.CHECKING}},
});

export const clearFWUStatus = () => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {
        data: {
            firmwareStatus: undefined,
            error: undefined,
        },
    },
});

export const clearFWUState = () => ({
    type: types.IOT_DEVICE_SET_FIRMWARE_DATA,
    payload: {
        data: {
            firmwareStatus: undefined,
            fwuTarget: undefined,
            progress: undefined,
            error: undefined,
        },
    },
});

export const refreshFeaturesConfigDate = () => ({type: types.IOT_DEVICE_REFRESH_FEATURES_CONFIG});
